import { IMessage } from "atlas-shared";
import { useMemo } from "react";
import { ConversationChatMessage } from "./conversation.chat_message";
import { TypingIndicator } from "./typing.indicator";
import "./conversation.chat_session.scss";

interface IProps {
  chatMessages?: IMessage[];
  userIsTyping?: boolean;
}

export const ConversationMessageChatSession = ({ chatMessages, userIsTyping = false }: IProps) => {
  const reversedMessages = useMemo(() => {
    return chatMessages ? [...chatMessages].reverse() : [];
  }, [chatMessages]);

  return (
    <div className={`conversation-chat-session`}>
      {reversedMessages.map((message: IMessage, index: number) => (
        <ConversationChatMessage key={index} message={message} />
      ))}
      {userIsTyping && <TypingIndicator />}
    </div>
  );
};
